// TODO: maybe better to move it in GraphQl
export enum TransferType {
  SEND_NOW = 'send-now',
  ONE_TIME = 'one-time',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  SAME_DAY = 'same-day',
  EVERY_TWO_WEEKS = 'every-two-weeks',
  SEMI_MONTHLY = 'semimonthly',
  MONTHLY = 'monthly',
  EVERY_THREE_MONTHS = 'every-three-months',
  EVERY_SIX_MONTHS = 'every-six-months',
  ANNUALLY = 'annually',
  LOAN_ON_DUE_DATE = 'loan-on-due-date',
  WEEK_OF_MONTH = 'week-of-month',
  LEGACY_WEEKLY = 'legacy-weekly',
  LEGACY_MONTHLY = 'legacy-monthly',
  LEGACY_ANNUALLY = 'legacy-annually',
  LEGACY_DAILY = 'legacy-daily',
}
